<div class="panel panel-plan bordered">

	@if (isBoxDisabled) {
	<div data-testid="SUBSYS2_PLANFORM_IMAGES_DISABLED_BOX" class="panel-plan-disabled"></div>
	}

	<div class="row">
		<div class="col-12">

			<div class="stepper pe-0 mb-4">
				<div class="stepper-icon" [class.success]="isImagesValid">b<i class="material-icons">done</i></div>
				<div data-testid="SUBSYS2_PLANFORM_IMAGES_TITLE_TXT" class="stepper-label">{{ title }}</div>
			</div>

			<div class="row">
				<div class=" col-6 col-xl-6">
					<attachment-uploader class="w-100" [title]="labels().IMAGE_LOADER_COMPONENT_AP_TITLE" [image]="apImage()"
						[view]="boneViewEnum.AP" [isInvalid]="form.controls.apImage.invalid" [isLoading]="!!isApLoading()"
						[isDisabled]="isReadonly" (removed)="removeApImage()" (zoomed)="openPreview(apImage()!)"
						(edited)="openCategorizationModal(apImage()!.id, apImage()!.fileName, boneViewEnum.AP)">

						<div class="uploader-warning">
							@if (form.controls.apImage.invalid) {
							<span class="invalid-feedback d-block">
								{{ form.controls.apImage | validationMsg:errorMsgs.apImage! | async }}
							</span>
							}
						</div>

					</attachment-uploader>
				</div>

				<div class="col-6 col-xl-6">
					<attachment-uploader class="w-100" [title]="labels().IMAGE_LOADER_COMPONENT_LT_TITLE" [image]="ltImage()"
						[view]="boneViewEnum.LAT" [isInvalid]="form.controls.ltImage.invalid" [isLoading]="!!isLtLoading()"
						[isDisabled]="isReadonly" (removed)="removeLtImage()" (zoomed)="openPreview(ltImage()!)"
						(edited)="openCategorizationModal(ltImage()!.id, ltImage()!.fileName, boneViewEnum.LAT)">

						<div class="uploader-warning">
							@if (form.controls.ltImage.invalid) {
							<span class="invalid-feedback d-block">
								{{ form.controls.ltImage | validationMsg:errorMsgs.ltImage! | async }}
							</span>
							}
						</div>

					</attachment-uploader>
				</div>
			</div>

		</div>
	</div>

</div>